import React, {Component} from 'react';
import { connect } from 'react-redux';
import Helpers from '../helpers';
import { fetchNotesIfNeeded, annotationStatus } from '../actions';
import WebnotesBar from '../components/WebnotesBar';
import NoteTool from '../components/NoteTool';
import Notes from '../components/Notes';

class Webnotes extends Component {
	constructor(props) {
		super(props)
	}

	componentDidMount() {
		const {dispatch} = this.props;
		dispatch(fetchNotesIfNeeded(window.location.href));
	}

	render() {
		return (
			<div className="WebnotesApp">
				<WebnotesBar viewAllSiteNotes={Helpers.t('viewAllSiteNotes')} addNote={Helpers.t('addNote')} annotator={Helpers.t('annotator')} />
				<Notes annotator={Helpers.t('annotator')} />
				{this.props.annotationStatus === 'annotating' && <NoteTool noteTitle={Helpers.t('noteTitle')} noteText={Helpers.t('noteText')} saveNote={Helpers.t('saveNote')} mousePosition={this.props.mousePosition} />}
			</div>
		)
	}
}
/*
const mapStateToProps = state => {
	const {
		isFetching,
		notes
	} = state.notes.length === 0 ? {
		isFetching: state.isFetching,
		notes: []
	} : {
		isFetching: state.isFetching,
		notes: state.notes
	}
	return {
		notes,
		isFetching
	}
};
*/
const mapStateToProps = state => state;
export default connect(mapStateToProps)(Webnotes);


// WEBPACK FOOTER //
// ./src/js/containers/Webnotes.js